<template>
  <div class="layout-column">
    <div class="flex-100 px-3 py-1 mb-6" :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">{{ $t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_HEADER' + (formKey === 'register' ? '_INITIAL' : '')) }}</span>
    </div>

    <!-- datum_psa -->

    <div class="flex-gt-sm-33 flex-100 px-2 mb-2">
      <validation-provider tag="div"
                           :name="path + '.datum_psa'"
                           :ref="path + '.datum_psa'"
                           :rules="{german_date:true,date_not_in_future:true,date_must_be_lesser_than_death:[deathDate,model.datum_psa_genauigkeit]}"
                           v-slot="{ errors }">
        <lx-datepicker
          :color="compColor.textInput"
          :name="path + '.datum_psa'"
          :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_DATE' + (formKey === 'register' ? '_INITIAL' : ''))"
          class="mr-1"
          @input="setDateAccuracyAfterDate"
          :dense="denseFields"
          :error="errors[0]"
          :hide-details="!errors || errors.length <= 0"
          :disabled="isDisabled"
          v-model="model.datum_psa"
        ></lx-datepicker>
      </validation-provider>
    </div>

    <!-- datum_psa_genauigkeit -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <div class="layout-row">
        <validation-provider tag="div"
                             class="flex"
                             :name="path + '.datum_psa_genauigkeit'"
                             :ref="path + '.datum_psa_genauigkeit'"
                             rules=""
                             v-slot="{ errors }">
          <v-select
              :color="compColor.primeColor"
              :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_DATE_ACCURACY' + (formKey === 'register' ? '_INITIAL' : ''))"
              v-model="model.datum_psa_genauigkeit"
              :items="DateAccuracyTypes"
              :disabled="isDisabled"
              outlined
              @change="validateDateAfterChangeOfAccuracy()"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on"
                           :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0">
                  <label style="cursor:pointer;"
                         :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                         class="lighten-4 text--darken-2">{{ item.text }}</label>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </validation-provider>

        <v-tooltip bottom open-delay="1000">
          <template v-slot:activator="{ on }">
            <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                 :class="{'mt-1': !denseFields}"
                 style="cursor: pointer;">
              <v-icon :color="compColor.prime" medium>info</v-icon>
            </div>
          </template>
          <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
        </v-tooltip>
      </div>
    </div>

    <!--psa -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.psa'"
                           :ref="path + '.psa'"
                           :rules="{decimal:3, between: [0,99999]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="isDisabled"
                        :dense="denseFields"
                        v-model="model.psa"
                        :hide-details="!errors || errors.length <= 0"
                        :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_PSA_VALUE' + (formKey === 'register' ? '_INITIAL' : ''))"
                        @input="setDateOfPSAPerDefault(model.psa)"
                        suffix="ng/ml"
                        separator=","
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>
    </div>

    <div class="flex-100 px-3 py-1 mb-6 mt-5"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">Gleason Score</span>
    </div>

    <!-- Gleason Score Grad Primär -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.gleason_score.gleason_grad_primaer'"
                           :ref="path + '.gleason_score.gleason_grad_primaer'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_PRIMARY')"
          v-model="model.gleason_score.gleason_grad_primaer"
          :items="gleasonGradPrimaerTypes"
          outlined
          @input="setGleasonResult"
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :disabled="isDisabled"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Gleason Score Grad Sekundär -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.gleason_score.gleason_grad_sekundaer'"
                           :ref="path + '.gleason_score.gleason_grad_sekundaer'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_SECONDARY')"
          v-model="model.gleason_score.gleason_grad_sekundaer"
          :items="gleasonGradSekundaerTypes"
          outlined
          @input="setGleasonResult"
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :disabled="isDisabled"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Gleason Score Grad Ergebnis -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.gleason_score.gleason_score_ergebnis'"
                           :ref="path + '.gleason_score.gleason_score_ergebnis'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_RESULT')"
          v-model="model.gleason_score.gleason_score_ergebnis"
          :items="gleasonScoreErgebnisTypes"
          outlined
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :disabled="isDisabled"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!--anlass_gleason_score -->

    <div class="flex-100 px-2 mb-6">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_REASON')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.anlass_gleason_score'"
                             :ref="path + '.anlass_gleason_score'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column px-4 pb-3 pt-2 flex">
            <v-radio-group :dense="denseFields" v-model="model.anlass_gleason_score" hide-details :error-messages="errors[0]"
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;" @change="setDateOfStanzaPerDefault(model.anlass_gleason_score)">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_REASON_RADIO_BUTTONS.OP')"
                       value="O" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_REASON_RADIO_BUTTONS.STANZA')"
                       value="S" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_GLEASON_SCORE_REASON_RADIO_BUTTONS.UNKNOWN')"
                       value="U" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>

              <!-- Reset value of anlass_gleason_score via button  -->

              <v-btn :color="compColor.primeColor"
                     :dark="compColor.isInDarkMode"
                     depressed
                     text
                     width="auto"
                     class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                     :class="denseFields ? 'pl-3' : ''"
                     @click="resetRadioButtons('anlass_gleason_score')"
                     v-show="model.anlass_gleason_score && !isDisabled"
                     :disabled="!model.anlass_gleason_score || isDisabled"
                     :title="$t('buttons.deleteSelection.title')">
                <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                        size="24">mdi-arrow-up-bold
                </v-icon>
                <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
              </v-btn>
            </v-radio-group>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <div class="flex-100 px-3 py-1 mb-6 mt-6"
         :class="isDarkMode ? 'blue-grey darken-3': compColor.prime + ' lighten-5'"
         style="border-radius: 4px;" v-if="model.anlass_gleason_score === 'S'">
      <span class="body-2 font-weight-bold" :style="{color: compColor.primeColor}">Stanzen</span>
    </div>

    <!--Stanzen (nur wenn Anlass Gleason Score ist S-Stanze) -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="model.anlass_gleason_score === 'S'">
      <validation-provider tag="div"
                           :name="path + '.anzahl_stanzen'"
                           :ref="path + '.anzahl_stanzen'"
                           :rules="{integer: true,between:[0,99], stanza_must_be_greater_than: [model.anzahl_pos_stanzen]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="isDisabled"
                        :dense="denseFields"
                        v-model="model.anzahl_stanzen"
                        :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_COUNT_STANZA')"
                        separator=","
                        :maxLength="2"
                        @input="refactorEmptyIntValue(model.anzahl_stanzen, null, 'anzahl_stanzen')"
                        :hint="$t('FORMS_DIVERSE.MODULE_PROSTATA_COUNT_STANZA_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>
    </div>

    <!-- Anzahl pos. Stanzen -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="model.anlass_gleason_score === 'S'">
      <validation-provider tag="div"
                           :name="path + '.anzahl_pos_stanzen'"
                           :ref="path + '.anzahl_pos_stanzen'"
                           :rules="{integer: true,between:[0,99], stanza_must_be_lesser_than: [model.anzahl_stanzen]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="isDisabled"
                        :dense="denseFields"
                        v-model="model.anzahl_pos_stanzen"
                        :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_COUNT_POSITIVE_STANZA')"
                        separator=","
                        :maxLength="2"
                        @input="refactorEmptyIntValue(model.anzahl_pos_stanzen, null, 'anzahl_pos_stanzen')"
                        :hint="$t('FORMS_DIVERSE.MODULE_PROSTATA_COUNT_STANZA_HINT')"
                        persistent-hint
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>
    </div>

    <!--datum_stanzen -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="model.anlass_gleason_score === 'S'">
      <validation-provider tag="div"
                           :name="path + '.datum_stanzen'"
                           :ref="path + '.datum_stanzen'"
                           rules="german_date|date_not_in_future"
                           v-slot="{ errors }">
        <lx-datepicker
          :color="compColor.textInput"
          :name="path + '.datum_stanzen'"
          :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_DATE_STANZA')"
          class="mr-1"
          :dense="denseFields"
          :error="errors[0]"
          :disabled="isDisabled"
          v-model="model.datum_stanzen"
        ></lx-datepicker>
      </validation-provider>
    </div>

    <!--ca_befall_stanze -->

    <div class="flex-gt-sm-50 flex-100 px-2 layout-row" v-if="model.anlass_gleason_score === 'S'">
      <validation-provider tag="div"
                           :name="path + '.ca_befall_stanze.prozentzahl'"
                           :ref="path + '.ca_befall_stanze.prozentzahl'"
                           :rules="{integer: true,between:[1,100]}"
                           v-slot="{ errors }">
        <lx-numberfield :disabled="model.ca_befall_stanze.u==='U' || isDisabled"
                        :dense="denseFields"
                        v-model="model.ca_befall_stanze.prozentzahl"
                        :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_INFESTATION_STANZA')"
                        separator=","
                        suffix="%"
                        :maxLength="3"
                        @input="refactorEmptyIntValue(model.ca_befall_stanze.prozentzahl, 'ca_befall_stanze', 'prozentzahl')"
                        :error-messages="errors[0]"
        ></lx-numberfield>
      </validation-provider>

      <div class="flex pl-5">
        <validation-provider tag="div"
                             :name="path + '.ca_befall_stanze.u'"
                             :ref="path + '.ca_befall_stanze.u'"
                             v-slot="{ errors }">
          <v-checkbox :label="$t('FORMS_DIVERSE.UNKNOWN')"
                      :dark="compColor.isInDarkMode"
                      :color="compColor.primeColor"
                      v-model="model.ca_befall_stanze.u"
                      value="U"
                      :error-messages="errors[0]"
                      class="mt-0 py-0"
                      :class="denseFields ? 'mt-n1' : 'mt-0'"
                      @change="model.ca_befall_stanze.prozentzahl=null"
                      :disabled="isDisabled">
          </v-checkbox>
        </validation-provider>
      </div>
    </div>

    <!-- Postoperative Komplikationen nach Clavien-Dindo (nur im Operationsbogen) -->

    <div class="flex-100 px-2 mb-6" v-show="formKey === 'operation'">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_CLAVIEN_DINDO')"
                        :disabled="isDisabled">
        <validation-provider tag="div"
                             :name="path + '.kompl_post_op_clavien_dindo'"
                             :ref="path + '.kompl_post_op_clavien_dindo'"
                             rules=""
                             class="flex layout-row"
                             v-slot="{ errors }">
          <div class="layout-column pa-4 flex">
            <div class="layout-row">
              <v-radio-group :dense="denseFields" v-model="model.kompl_post_op_clavien_dindo" hide-details :error-messages="errors[0]"
                             class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
                <div class="text--lighten-1 layout-row layout-align-start-center"
                     @click="showTableForSideEffects=true"
                     style="cursor: pointer;">
                  <v-icon :color="compColor.prime" medium>info</v-icon>
                  <span class="ml-2 body-2" :style="{color: compColor.primeColor}">Informationen zu Clavien-Dindo</span>
                </div>
                <v-divider class="my-2" v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>
                <v-radio :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_CLAVIEN_DINDO_RADIO_BUTTONS.YES')"
                         value="J"
                         :disabled="isDisabled"
                         :color="compColor.primeColor"
                         :dark="compColor.isInDarkMode">
                </v-radio>
                <v-radio :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_CLAVIEN_DINDO_RADIO_BUTTONS.GRADE_TWO')"
                         value="N"
                         :disabled="isDisabled"
                         :color="compColor.primeColor"
                         :dark="compColor.isInDarkMode">
                </v-radio>
                <v-radio :label="$t('FORMS_DIVERSE.MODULE_PROSTATA_CLAVIEN_DINDO_RADIO_BUTTONS.UNKNOWN')"
                         value="U"
                         :disabled="isDisabled"
                         :color="compColor.primeColor"
                         :dark="compColor.isInDarkMode">
                </v-radio>

                <!-- Reset value of kompl_post_op_clavien_dindo via button  -->

                <v-btn :color="compColor.primeColor"
                       :dark="compColor.isInDarkMode"
                       depressed
                       text
                       width="auto"
                       class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                       :class="denseFields ? 'pl-3' : ''"
                       @click="resetRadioButtons('kompl_post_op_clavien_dindo')"
                       v-show="model.kompl_post_op_clavien_dindo && !isDisabled"
                       :disabled="!model.kompl_post_op_clavien_dindo || isDisabled"
                       :title="$t('buttons.deleteSelection.title')">
                  <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                          size="24">mdi-arrow-up-bold
                  </v-icon>
                  <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
                </v-btn>
              </v-radio-group>
            </div>
          </div>
        </validation-provider>
      </fake-input-frame>
    </div>

    <!-- Legende zu Glavien Dindo -->

    <v-dialog max-width="900px" v-model="showTableForSideEffects">
      <v-card>
        <v-card-title class="layout-column">
          <h2>Komplikationsklassifikation</h2>
          <h5>modifiziert nach Clavien (1,2)</h5>
        </v-card-title>
        <v-card-text class="pt-1">
          <div class="table-side-effects">
            <table>
              <colgroup>
                <col style="width:55px;max-width:55px;">
                <col>
              </colgroup>
              <thead>
              <tr>
                <th class="text-xs-left pl-2 py-2">Grad</th>
                <th class="text-xs-left pl-2 py-2">Definition</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><span>Grad I</span></td>
                <td>
                  <div class="layout-column pa-2">
                    <span>Jede Abweichung vom normalen postoperativen Verlauf ohne Notwendigkeit einer pharmakologischen, operativen, endoskopischen oder radiologischen Intervention. Erlaubtes therapeutisches Regime: Medikamente wie Antiemetika,</span>
                    <span>Antipyretika,Diuretika, Elektrolyte und Physiotherapie</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><span>Grad II</span></td>
                <td>
                  <div class="layout-column pa-2">
                    <span>Bedarf an medikamentöser Behandlung mit nicht unter Grad I angeführten Medikamenten inklusive parenterale Ernährung und Bluttransfusionen</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><span>Grad III</span></td>
                <td>
                  <div class="layout-column pa-2">
                    <span>Komplikationen mit chirurgischem, endoskopischen oder radiologischem Interventionsbedarf</span>
                    <span>(Untergrade: IIIa - Ohne Vollnarkose, IIIb - Mit Vollnarkose)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><span>Grad IV</span></td>
                <td>
                  <div class="layout-column pa-2">
                    <span>Lebensbedrohliche Komplikationen (einschließlich ZNS-Komplikationen wie Hirnblutung, ischämischer Insult, Subarachnoidalblutung jedoch exklusive TIA), die eine intensivmedizinische Behandlung verlangen</span>
                    <span>(Untergrade: IVa - Dysfunktion eines Organs (inklusive Dialyse), IVb - Dysfunktion multipler Organe)</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><span>Grad V</span></td>
                <td>
                  <div class="layout-column pa-2"><span>Tod des Patienten</span></div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4 pl-4"><span>Quelle: https://www.assessurgery.com/clavien-dindo-classification/ (Stand: März 2023)</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <lx-btn @click.stop="showTableForSideEffects=false"
                  :width="'auto'"
                  :height="32"
                  :color="compColor.primeColor"
                  :label="$t('buttons.close.value')"
                  :dark="compColor.isInDarkMode">
          </lx-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'

export default {
  name: "ModulProstata",
  mixins: [metaData, utils],
  props: {
    value: {
      type: Object,
      default: () => ({gleason_score: {}, ca_befall_stanze: {}})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    base: {
      type: Object
    },
    formKey: {
      type: String
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    patientId: {
      type: String
    }
  },
  data () {
    return {
      testModel: null,
      model: {
        gleason_score: {},
        ca_befall_stanze: {}
      },
      showTableForSideEffects: false,
      gleasonGradPrimaerTypes: null,
      gleasonGradSekundaerTypes: null,
      gleasonScoreErgebnisTypes: null,
      DateAccuracyTypes: null
    }
  },
  created () {
    this.gleasonGradPrimaerTypes = this.formsMetaData.GleasonGradPrimaerTypes
    this.gleasonGradSekundaerTypes = this.formsMetaData.GleasonGradSekundaerTypes
    this.gleasonScoreErgebnisTypes = this.formsMetaData.GleasonScoreErgebnisTypes
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyShort
  },
  methods: {
    /**
     * Reset selected radio-button and trigger dirty flag of validator for save
     */
    resetRadioButtons (field) {
      this.$set(this.model, field, null)

      if (field === 'anlass_gleason_score') {
        // delete existing values of stanza
        this.setDateOfStanzaPerDefault('reset')
      }

      this.validationRef.fields[this.path + '.' + field].changed = true
    },

    /**
     * Set date accuracy per default after date input
     */
    setDateAccuracyAfterDate () {
      // set datum_psa_genauigkeit if not exists after changing datum_psa in datepicker
      if (this.model.datum_psa && !this.model.datum_psa_genauigkeit) {
        this.$set(this.model, 'datum_psa_genauigkeit', 'E')
      }
    },

    /**
     * Validate date after changing date accuracy
     */
    validateDateAfterChangeOfAccuracy () {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.datum_psa']) {
          this.$refs[this.path + '.datum_psa'].validate()
        }
      })
    },

    /**
     * Set date of PSA per default in dependency to form type
     *
     * @param value THe psa value
     */
    setDateOfPSAPerDefault (value) {
      let date

      // get date of form in base data
      switch (this.formKey) {
        case 'register':
          date = this.base && this.base.diagnosedatum ? this.base.diagnosedatum : null
          break
        case 'progress':
          date = this.base && this.base.untersuchungsdatum_verlauf ? this.base.untersuchungsdatum_verlauf : null
          break
        case 'operation':
          date = this.base && this.base.op_datum ? this.base.op_datum : null
          break
        default:
          date = null
      }

      if (value && !this.model.datum_psa) {
        this.$set(this.model, 'datum_psa', date)
      }

      this.refactorEmptyIntValue(value, null, 'psa')
    },

    /**
     * Set date of stanza per default in dependency to value of reason of gleason-score
     *
     * @param value THe gleason-score value
     */
    setDateOfStanzaPerDefault (value) {
      let date

      // set date of stanza only in register form
      if (this.formKey === 'register' && value && value === 'S' && !this.model.datum_stanzen) {
        date = this.base && this.base.diagnosedatum ? this.base.diagnosedatum : null
        this.$set(this.model, 'datum_stanzen', date)
      } else if (value && value !== 'S') {
        // delete all stanza elements if reason for gleason score is not stanza (all forms)
        this.$delete(this.model, 'datum_stanzen')
        this.$delete(this.model, 'anzahl_stanzen')
        this.$delete(this.model, 'anzahl_pos_stanzen')
        this.$set(this.model, 'ca_befall_stanze', {})
      }
    },

    /**
     * Return the result of gleason score from addition of gleason grad primary and gleason grad secondary
     */
    setGleasonResult () {
      if (this.model.gleason_score.gleason_grad_primaer && this.model.gleason_score.gleason_grad_sekundaer) {
        let a = parseInt(this.model.gleason_score.gleason_grad_primaer, 10)
        let b = parseInt(this.model.gleason_score.gleason_grad_sekundaer, 10)
        let ergebnis = a + b

        if (ergebnis === 7 && (a === 3 || a === 4)) {
          ergebnis = a === 3 ? '7a' : '7b'
        } else {
          ergebnis = ergebnis.toString()
        }

        this.$set(this.model.gleason_score, 'gleason_score_ergebnis', ergebnis)
      }

      // set anlass_gleason_score per default if primary or secondary score is set
      if (!this.model.anlass_gleason_score) {
        let date = this.base && this.base.diagnosedatum ? this.base.diagnosedatum : null
        this.$set(this.model, 'datum_stanzen', date)
        this.$set(this.model, 'anlass_gleason_score', 'S')
      }
    }
  },
  computed: {
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    'base.primaertumor_icd_code': {
      // reset module if already existing icd10 code has been changed
      handler: function (newValue, oldValue) {
        if (newValue && oldValue && newValue !== oldValue && !this.isDisabled) {
          this.model = {
            gleason_score: {},
            ca_befall_stanze: {}
          }
        }
      },
      immediate: true
    },
    'base.diagnosedatum': {
      // reset module if already existing icd10 code has been changed
      handler: function (newValue, oldValue) {
        if (newValue && newValue !== oldValue && this.formKey === 'register' && this.model.anlass_gleason_score === 'S' && !this.isDisabled) {
          this.$set(this.model, 'datum_stanzen', newValue)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.table-side-effects {
  table {
    border: 1px solid #e0e0e0;
    border-spacing: 0;
    margin: 25px;

    thead {
      tr {
        background: darkgrey;
      }
    }

    tbody {
      tr {
        border: 0;
      }

      td {
        border-bottom: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        border-top: 0;
        border-left: 0;
        /*height: 35px;*/
        &:last-child {
          border-right: 0;
        }

        span {
          padding-left: 5px;
        }
      }
    }
  }
}
</style>
